/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  getFetchParams,
  InterviewId,
  InterviewWithAIAssistant,
  IPosition,
  requestAssemblyUserToken,
  TranslatedText
} from 'core'
import { useCallback, useEffect, useRef, useState } from 'react'
// import { RecordRTCPromisesHandler, StereoAudioRecorder } from 'recordrtc'
import { v4 as uuidv4 } from 'uuid'

import { toast } from '~/lite'
import { playAudioWithStream, withAudioLevels, withMicrophoneLevels } from '~/util'

import { useUpdateInterviewMessageAudio } from './api'
import { useAudioPlayer } from './useAudioPlayer'
import { useUppy } from './useUppy'

export interface IAssemblyRecordMessage {
  audio_start: number
  audio_end: number
  confidence: number
  text: string
  words: {
    confidence: number
    text: string
    start: number
    end: number
  }[]
  created: string
  message_type: 'PartialTranscript' | 'FinalTranscript'
}

type RecordState = 'idle' | 'establishing' | 'recording' | 'processing' | 'playback' | 'paused'
const emptyAudioBase64 =
  'UklGRooWAABXQVZFZm10IBAAAAABAAEAIlYAAESsAAACABAAZGF0YWYWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'
const websocketErrorCode = 1000

export const useInterviewRecorder = (
  jobId: IPosition['id'],
  isSpeakerMuted: boolean,
  audioVisualizerRef?: React.RefObject<HTMLDivElement>
) => {
  const audioContext = useRef<AudioContext | null>(null)
  const [recordState, setRecordState] = useState<RecordState>('idle')
  const [isReady, setIsReady] = useState(false)
  const [isEnded, setIsEnded] = useState(false)

  const [userSpeech, setUserSpeech] = useState<string>('')
  const [assistantSpeech, setAssistantSpeech] = useState<string>('')
  const {
    setAudioBlobData,
    play: playRecord,
    hasAudioSource: hasRecorded,
    isPlaying
  } = useAudioPlayer(audioVisualizerRef)
  const { uppy } = useUppy({
    autoProceed: true
  })
  const { mutateAsync: updateInterviewMessageAudio } = useUpdateInterviewMessageAudio()
  const unsubscribeRef = useRef<
    ReturnType<typeof withAudioLevels> | Awaited<ReturnType<typeof withMicrophoneLevels>> | null
  >(null)

  const messages = useRef<IAssemblyRecordMessage[]>([])
  // const lastProcessedMessageIndex = useRef<number>(0)
  const assemblyWebSocket = useRef<WebSocket | null>(null)
  const rtcRecorder = useRef<any>(null)
  const recordStartTime = useRef<number>(new Date().getTime())
  const interviewId = useRef<InterviewId>(uuidv4() as InterviewId)
  const recordIsPausing = useRef<boolean>(false)
  const setVolumeRef = useRef<ReturnType<typeof playAudioWithStream>['setVolume'] | null>(null)
  const callbackRef = useRef<(() => Promise<void>) | null>(null)

  const getAudioContext = useCallback(() => {
    if (!audioContext.current) {
      audioContext.current = new (window.AudioContext || (window as any).webkitAudioContext)()
    }
    return audioContext.current
  }, [])

  useEffect(() => {
    if (isSpeakerMuted) {
      setVolumeRef.current?.(0)
    } else {
      setVolumeRef.current?.(1)
    }
  }, [isSpeakerMuted])

  const initWebsocket = useCallback(async (onSuccess?: () => void) => {
    if (assemblyWebSocket.current) {
      onSuccess?.()
      return
    }
    setRecordState('establishing')
    let intervalId: NodeJS.Timer
    const tokenResponse = await requestAssemblyUserToken()
    if (tokenResponse.success) {
      const assemblyUserToken = tokenResponse.token

      assemblyWebSocket.current = new WebSocket(
        `wss://api.assemblyai.com/v2/realtime/ws?sample_rate=16000&token=${assemblyUserToken}`
      )
      assemblyWebSocket.current.onmessage = async message => {
        const messageItem = JSON.parse(message.data) as IAssemblyRecordMessage
        if (!messageItem.text) {
          return
        }
        // setUserSpeech(prev => prev + messageItem.text)
        if (messages.current[messages.current.length - 1]?.audio_start === messageItem.audio_start) {
          messages.current[messages.current.length - 1] = messageItem
        } else {
          messages.current.push(messageItem)
        }
        setUserSpeech(messages.current.map(message => message.text).join(''))
        // setLastMessages(messages.current.slice(-2)) // get last 2 messages
      }

      assemblyWebSocket.current.onerror = async event => {
        assemblyWebSocket.current?.close(websocketErrorCode)
        rtcRecorder.current && (await rtcRecorder.current.stopRecording())
        rtcRecorder.current = null
      }

      assemblyWebSocket.current.onclose = event => {
        assemblyWebSocket.current = null
        clearInterval(intervalId)
        if (!event.wasClean || event.code !== websocketErrorCode) {
          initWebsocket()
        }
      }

      assemblyWebSocket.current.onopen = async () => {
        onSuccess?.()
        //keep alive every 30 seconds
        intervalId = setInterval(() => {
          if (recordIsPausing.current) {
            assemblyWebSocket.current?.send(JSON.stringify({ audio_data: emptyAudioBase64 }))
          }
        }, 10000)
      }
    }
  }, [])

  const startRecording = useCallback(() => {
    callbackRef.current = async () => {
      setRecordState('recording')
      if (rtcRecorder.current) {
        await rtcRecorder.current.resumeRecording()
        return
      }
      const { RecordRTCPromisesHandler, StereoAudioRecorder } = await import('recordrtc')
      // once socket is open, begin recording
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      unsubscribeRef.current = await withMicrophoneLevels(stream, volume => {
        if (audioVisualizerRef?.current) {
          const scale = Math.min(0.5 + volume / 100, 1)
          audioVisualizerRef.current.style.transform = `scale3d(${scale}, ${scale}, ${scale})`
        }
      })
      rtcRecorder.current = new RecordRTCPromisesHandler(stream, {
        type: 'audio',
        mimeType: 'audio/webm;codecs=pcm', // endpoint requires 16bit PCM audio
        recorderType: StereoAudioRecorder,
        timeSlice: 250, // set 250 ms intervals of data that sends to AAI
        desiredSampRate: 16000,
        numberOfAudioChannels: 1, // real-time requires only one channel
        bufferSize: 4096,
        audioBitsPerSecond: 128000,
        ondataavailable: blob => {
          const reader = new FileReader()
          reader.onload = () => {
            const base64data = reader.result
            // audio data must be sent as a base64 encoded string
            if (assemblyWebSocket.current && base64data) {
              assemblyWebSocket.current.send(JSON.stringify({ audio_data: base64data.toString().split('base64,')[1] }))
            }
          }
          reader.readAsDataURL(blob)
        }
      })
      await rtcRecorder.current.startRecording()
      recordStartTime.current = new Date().getTime()
    }
    return new Promise<void>(resolve => {
      initWebsocket(async () => {
        await callbackRef.current?.()
        callbackRef.current = null
        resolve()
      })
    })
  }, [audioVisualizerRef, initWebsocket])

  useEffect(() => {
    return () => {
      if (assemblyWebSocket.current) {
        assemblyWebSocket.current.send(JSON.stringify({ terminate_session: true }))
        assemblyWebSocket.current.close()
      }

      if (rtcRecorder.current) {
        rtcRecorder.current.stopRecording()
      }
    }
  }, [initWebsocket])

  const toggle = useCallback(
    async (callback?: (state: 'start' | 'stop') => void) => {
      if (recordState === 'paused') {
        await startRecording()
        recordIsPausing.current = false
        callback?.('start')
      } else {
        if (recordState === 'processing') {
          return
        }
        if (recordState === 'idle') {
          // start the interview
          // prepare the websocket to get rid of the assembly token request time
          initWebsocket()
        }
        callback?.('stop')
        setIsReady(false)
        setRecordState('processing')
        let messageId: string | undefined
        if (recordState !== 'idle') {
          messageId = uuidv4()
          if (rtcRecorder.current) {
            await rtcRecorder.current.stopRecording()
            const duration = new Date().getTime() - recordStartTime.current
            if (uppy) {
              const blob = await rtcRecorder.current.getBlob()
              new Promise<void>((resolve, reject) => {
                uppy.addFile({
                  name: `message-${messageId}.mp3`,
                  type: 'audio/mpeg',
                  data: blob
                })
                uppy.once('complete', result => {
                  const uploadResult = result.successful[0]
                  updateInterviewMessageAudio({
                    role: 'user',
                    jobId,
                    interviewId: interviewId.current,
                    messageId: messageId!,
                    audioFileUrl: uploadResult.uploadURL,
                    audioDuration: duration
                  })
                  uppy.cancelAll()
                  resolve()
                })
                uppy.once('error', error => {
                  reject(error.message)
                })
              })
            }
            rtcRecorder.current = null
          }
        }
        recordIsPausing.current = true
        if (userSpeech || recordState === 'idle') {
          setRecordState('playback')

          const [endpoint, options] = getFetchParams<InterviewWithAIAssistant>('POST', '/interviews/assistant', {
            data: {
              jobId,
              messageId,
              message: recordState !== 'idle' ? userSpeech : undefined,
              interviewId: interviewId.current
            }
          })
          setUserSpeech('')
          messages.current = []

          const streamDestination = getAudioContext().createMediaStreamDestination()
          // const micStream = await navigator.mediaDevices.getUserMedia({ audio: true })
          // const micSource = getAudioContext().createMediaStreamSource(micStream)
          // micSource.connect(streamDestination)
          // const { RecordRTCPromisesHandler, StereoAudioRecorder } = await import('recordrtc')
          // rtcRecorder.current = new RecordRTCPromisesHandler(streamDestination.stream, {
          //   type: 'audio',
          //   mimeType: 'audio/webm;codecs=pcm', // endpoint requires 16bit PCM audio
          //   recorderType: StereoAudioRecorder,
          //   desiredSampRate: 16000,
          //   numberOfAudioChannels: 2,
          //   bufferSize: 4096,
          //   audioBitsPerSecond: 128000
          // })
          // await rtcRecorder.current.startRecording()
          // recordStartTime.current = new Date().getTime()
          if (unsubscribeRef.current) {
            unsubscribeRef.current()
            unsubscribeRef.current = withAudioLevels(
              streamDestination.stream,
              volume => {
                if (audioVisualizerRef?.current) {
                  const scale = Math.min(0.5 + volume / 100, 1)
                  audioVisualizerRef.current.style.transform = `scale3d(${scale}, ${scale}, ${scale})`
                }
              },
              false
            )
          }
          setAssistantSpeech('Waiting for the interviewer response...' as TranslatedText)
          const { setVolume } = playAudioWithStream({
            audioContext: getAudioContext(),
            streamDestination,
            fetchParams: [endpoint, options],
            initialVolume: isSpeakerMuted ? 0 : 1,
            onStart: () => setAssistantSpeech(''),
            onTranscriptAdded: (transcript, transcriptStartTime, audioDuration) => {
              setTimeout(() => setAssistantSpeech(prev => prev + transcript), transcriptStartTime)
            },
            onEnd: async (error, buffer, assistantMessageId, isEnded) => {
              setRecordState('paused')
              if (error) {
                toast.failure(error)
                return
              }
              if (buffer) {
                setAudioBlobData(new Blob([buffer], { type: 'audio/mpeg' }))
              }
              // await rtcRecorder.current.stopRecording()
              // const duration = new Date().getTime() - recordStartTime.current
              // micSource.disconnect()
              // const blob = await rtcRecorder.current.getBlob()
              // setAudioBlobData(blob)
              // rtcRecorder.current = null
              setIsReady(true)
              unsubscribeRef.current?.()
              unsubscribeRef.current = null
              // if (uppy && assistantMessageId) {
              //   await new Promise<void>((resolve, reject) => {
              //     uppy.addFile({
              //       name: `message-${assistantMessageId}.mp3`,
              //       type: 'audio/mpeg',
              //       data: blob
              //     })
              //     uppy.once('complete', async result => {
              //       const uploadResult = result.successful[0]
              //       updateInterviewMessageAudio({
              //         role: 'assistant',
              //         jobId,
              //         interviewId: interviewId.current,
              //         messageId: assistantMessageId,
              //         audioFileUrl: uploadResult.uploadURL,
              //         audioDuration: duration
              //       })
              //       uppy.cancelAll()
              //       resolve()
              //     })
              //     uppy.once('error', error => {
              //       reject(error.message)
              //     })
              //   })
              // }
              if (isEnded) {
                setIsEnded(true)
              }
            }
          })
          setVolumeRef.current = setVolume
        } else {
          setRecordState('paused')
          setIsReady(true)
        }
      }
    },
    [
      audioVisualizerRef,
      getAudioContext,
      initWebsocket,
      isSpeakerMuted,
      jobId,
      recordState,
      setAudioBlobData,
      startRecording,
      updateInterviewMessageAudio,
      uppy,
      userSpeech
    ]
  )

  return {
    isReady,
    isEnded,
    recordState,
    toggleRecord: toggle,
    userSpeech,
    assistantSpeech,
    playRecord,
    hasRecorded,
    isReplayingRecord: isPlaying
  }
}
